import React from 'react';
import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

// Pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import PrivatePayroll from './pages/PrivatePayroll';
import ToYou from './pages/ToYou';
import ToCompany from './pages/ToCompany';
import Help from './pages/Help';
import EnterNow from './pages/EnterNow';
import PrivacyPolicy from './pages/PrivacyPolicy';
import UseTerms from './pages/UseTerms';
import Simulation from './pages/Simulation';

// Components
import Header from './components/Header';

export default function Routes() {
  return(
    <BrowserRouter>
      <Header/>
      <Switch>
        <Route exact path="/demo/" component={Home}/>
        <Route path="/demo/quem-somos/" component={AboutUs}/>
        <Route path="/demo/consignado-privado/" component={PrivatePayroll}/>
        <Route path="/demo/para-voce/" component={ToYou}/>
        <Route path="/demo/para-empresas/" component={ToCompany}/>
        <Route path="/demo/ajuda/" component={Help}/>
        <Route path="/demo/entre-agora/" component={EnterNow}/>
        <Route path="/demo/simulacao/" component={Simulation}/>
        <Route path="/demo/politica-privacidade/" component={PrivacyPolicy}/>
        <Route path="/demo/termos-uso/" component={UseTerms}/>
      </Switch>
    </BrowserRouter>
  )
}